// eslint-disable-next-line no-shadow
export enum Locale {
  EN = "en",
  FR = "fr",
  NL = "nl",
  ES = "es",
  DE = "de",
}

export const LOCALE_OPTIONS: { value: Locale; label: string }[] = [
  { value: Locale.EN, label: "English" },
  { value: Locale.FR, label: "Français" },
  { value: Locale.NL, label: "Nederlands" },
];

export const DEFAULT_LOCALE = Locale.EN;
